import React from 'react'

import { PageContent } from 'common'
import { SignalFeedback } from 'components'
import { Button } from 'common/styles/layouts'

import { TUnavailableFeatureView } from '../types/UnavailableFeature.types'

export function UnavailableFeatureView({
  title,
  details,
  icon,
  type,
  button,
  email,
  onclick,
}: TUnavailableFeatureView) {
  return (
    <PageContent>
      <SignalFeedback
        title={title}
        details={`${details}`}
        strongDetails={email}
        icon={icon}
        type={type}
      />
      <Button onClick={onclick}>{button}</Button>
    </PageContent>
  )
}
